import CommonMiddleware from 'yoda-site-components/lib/middlewares/CommonMiddleware';
import AccountComponentsMiddleware from 'yoda-account-components/lib/middlewares/AccountComponentsMiddleware';
import CommonCJAMiddleware from 'yoda-site-components/lib/middlewares/CommonCJAMiddleware';
import AccountAnalyticsMiddleware from './AccountAnalyticsMiddleware';

const rootMiddleware = [
    CommonMiddleware,
    CommonCJAMiddleware,
    AccountAnalyticsMiddleware,
    AccountComponentsMiddleware,
];

export default rootMiddleware;
